import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {ExternalTenantMgmtListComponent} from './external-tenant-mgmt-list.component';

const routes: Routes = [
  {
    path: '',
    component: ExternalTenantMgmtListComponent,
    title: 'Tenant'
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ExternalTenantMgmtListRoutingModule {
}
